module.exports = __webpack_public_path__ + "static/img/icons8-combo_chart.a6ad605d.svg";